import { createContext, useEffect, useReducer } from 'react';
import AuthReducer from './AuthReducer';
import { UpdatePlayer } from './AuthActions'; // Import the UpdatePlayer action creator
import { classifyAuthToken } from '../utils/authTokenClassifier';

const readStoredPlayer = () => {
  try {
    const parsed = JSON.parse(localStorage.getItem('player')) || null;
    if (parsed?.token && classifyAuthToken(parsed.token).type !== 'session') {
      localStorage.removeItem('player');
      return null;
    }
    return parsed;
  } catch (err) {
    localStorage.removeItem('player');
    return null;
  }
};

const INITIAL_STATE = {
  player: readStoredPlayer(),
  isFetching: false,
  error: false,
};

export const AuthContext = createContext(INITIAL_STATE);

export const AuthContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(AuthReducer, INITIAL_STATE);

  useEffect(() => {
    if (state.player) {
      localStorage.setItem('player', JSON.stringify(state.player));
    } else {
      localStorage.removeItem('player');
    }
  }, [state.player]);

  // Define the updatePlayer function
  const updatePlayer = (playerData) => {
    dispatch(UpdatePlayer(playerData));
  };

  return (
    <AuthContext.Provider
      value={{
        player: state.player,
        isFetching: state.isFetching,
        error: state.error,
        dispatch,
        updatePlayer, // Add the updatePlayer function to the context value
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
